import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

// project import
import config from 'config';
import useAuth from 'hooks/useAuth';

// types
import { GuardProps } from 'types/auth';

// ==============================|| GUEST GUARD ||============================== //

const GuestGuard = ({ children }: GuardProps) => {
  const { isLoggedIn, user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (user && (user.newDealerStatus !== 'C'))
      config.defaultPath = '/newdealer/pricelist/list';
    else
      config.defaultPath = '/subscriptions/pricelist/list';

    if (isLoggedIn)
      navigate(config.defaultPath, { replace: true });
  }, [isLoggedIn, navigate]);

  return children;
};

export default GuestGuard;
